import { Wrench } from 'lucide-react';
import { Callout } from '@/components/shared/Callout';
import { useMaintenance } from '@/hooks/config/useMaintenance';

/**
 * Persistent banner shown above the main content whenever an admin has enabled
 * platform maintenance mode. It never blocks navigation or dismisses itself —
 * the app stays fully usable and the banner clears only when maintenance mode
 * is turned off in the admin panel. Renders nothing when disabled or when no
 * message has been set.
 */
export function MaintenanceBanner() {
  const { enabled, message } = useMaintenance();
  if (!enabled || message.trim().length === 0) return null;

  return (
    <div className="shrink-0 px-4 pt-3" role="status" aria-live="polite">
      <Callout icon={Wrench} variant="warning" className="whitespace-pre-wrap">
        {message}
      </Callout>
    </div>
  );
}
